module.exports = __webpack_public_path__ + "static/media/heart_icon.250ef896.svg";